import { render, staticRenderFns } from "./RechargeSuccessModal.vue?vue&type=template&id=a2230546&scoped=true"
import script from "./RechargeSuccessModal.vue?vue&type=script&lang=js"
export * from "./RechargeSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./RechargeSuccessModal.vue?vue&type=style&index=0&id=a2230546&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2230546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2230546')) {
      api.createRecord('a2230546', component.options)
    } else {
      api.reload('a2230546', component.options)
    }
    module.hot.accept("./RechargeSuccessModal.vue?vue&type=template&id=a2230546&scoped=true", function () {
      api.rerender('a2230546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/Modal/RechargeSuccessModal.vue"
export default component.exports